import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { SignComponent } from './sign/sign.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginComponent } from './login.component';

import { LoginRoutes } from './login.routing';
import { SignService } from './sign/service/sign.service';
import { ForgotService } from './forgot/service/forgot.service';
import { ChangePasswordService } from './change-password/service/change-password.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule.forChild(LoginRoutes),
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    SignComponent, 
    ForgotComponent, 
    ChangePasswordComponent,
    LoginComponent],
    providers: [SignService, ForgotService, ChangePasswordService]
  })
export class LoginModule { }